import { useCallback, useEffect, useState } from "react";
import client from "@/lib/api";

const STATUS_STYLE = {
  Active: "bg-[#D1FAE5] text-[#065F46] border-[#34D399]",
  Pending: "bg-[#FEF3C7] text-[#92400E] border-[#FBBF24]",
};

export default function AdminPayments() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => client.get("/admin/payments").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const total = items.reduce((sum, i) => sum + (i.status === "Active" ? i.amount_eur : 0), 0);

  return (
    <div data-testid="admin-payments-page">
      <div className="text-[11px] uppercase tracking-[0.3em] text-[#64748B] mb-1">Admin · Payments</div>
      <h1 className="trent-heading text-3xl md:text-4xl font-black tracking-tighter text-[#0F172A] mb-6">
        Payments
      </h1>

      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-white border border-[#E5E7EB] rounded-md p-5">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#64748B]">Active MRR</div>
          <div className="trent-heading text-3xl font-black text-[#0F172A] mt-1">€{total}</div>
        </div>
        <div className="bg-white border border-[#E5E7EB] rounded-md p-5">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#64748B]">Active accounts</div>
          <div className="trent-heading text-3xl font-black text-[#0F172A] mt-1">
            {items.filter((i) => i.status === "Active").length}
          </div>
        </div>
        <div className="bg-white border border-[#E5E7EB] rounded-md p-5">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#64748B]">Pending</div>
          <div className="trent-heading text-3xl font-black text-[#0F172A] mt-1">
            {items.filter((i) => i.status === "Pending").length}
          </div>
        </div>
      </div>

      <div className="bg-white border border-[#E5E7EB] rounded-md overflow-hidden">
        <div className="px-4 py-3 bg-[#F1F5F9] text-[10px] uppercase tracking-[0.25em] text-[#64748B] font-semibold">
          Subscriptions & billing (Stripe pending wire-up)
        </div>
        <table className="w-full text-sm">
          <thead className="bg-[#F1F5F9] text-[10px] uppercase tracking-[0.2em] text-[#64748B]">
            <tr>
              <th className="text-left px-4 py-3">Customer</th>
              <th className="text-left px-4 py-3 hidden md:table-cell">Email</th>
              <th className="text-left px-4 py-3">Plan</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-right px-4 py-3">Amount</th>
              <th className="text-left px-4 py-3 hidden md:table-cell">Since</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={6} className="text-center text-[#64748B] py-10">No billing records yet.</td></tr>
            )}
            {items.map((p) => (
              <tr key={p.id} className="border-t border-[#E5E7EB]" data-testid={`payment-row-${p.id}`}>
                <td className="px-4 py-3 font-semibold">{p.user_name}</td>
                <td className="px-4 py-3 hidden md:table-cell text-[#475569]">{p.user_email}</td>
                <td className="px-4 py-3">{p.plan}</td>
                <td className="px-4 py-3">
                  <span className={`condition-pill ${STATUS_STYLE[p.status] || ""}`}>{p.status}</span>
                </td>
                <td className="px-4 py-3 text-right font-semibold">€{p.amount_eur}</td>
                <td className="px-4 py-3 hidden md:table-cell text-[#64748B] text-xs">
                  {p.billed_at?.slice(0, 10)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
